<template>
  <div class="flex flex-col justify-between items-center">
    <div class="result-icon-container">
      <svg v-if="isCorrect" class="resultsIcon" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink" width="116"
           height="116" viewBox="0 0 116 116">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_22" data-name="Rectangle 22" width="52.225" height="40.279" fill="#fff"/>
          </clipPath>
        </defs>
        <g id="tick" transform="translate(-137 -117)">
          <circle id="Ellipse_3" data-name="Ellipse 3" cx="58" cy="58" r="58" transform="translate(137 117)"
                  fill="#47c81a"/>
          <g id="Group_11" data-name="Group 11" transform="translate(172.893 154.86)">
            <g id="Group_10" data-name="Group 10" transform="translate(0 0)" clip-path="url(#clip-path)">
              <path id="Path_6" data-name="Path 6"
                    d="M50.775,1.45a4.942,4.942,0,0,0-6.99-.005l-.005.005L16.917,28.314,8.445,19.842a4.942,4.942,0,0,0-6.99-.005l-.005.005a4.942,4.942,0,0,0-.005,6.99l.005.005,12,11.991a4.942,4.942,0,0,0,6.99.005l.005-.005L50.784,8.436a4.942,4.942,0,0,0-.009-6.986"
                    transform="translate(0 0)" fill="#fff"/>
            </g>
          </g>
        </g>
      </svg>

      <svg v-else class="resultsIcon" xmlns="http://www.w3.org/2000/svg" width="116" height="116"
           viewBox="0 0 116 116">
        <g id="X" transform="translate(-137 -117)">
          <circle id="Ellipse_3" data-name="Ellipse 3" cx="58" cy="58" r="58" transform="translate(137 117)"
                  fill="red"/>
          <g id="Group_12" data-name="Group 12">
            <rect id="Rectangle_23" data-name="Rectangle 23" width="9" height="71" rx="4.5"
                  transform="translate(166.716 153.08) rotate(-45)" fill="#fff"/>
            <rect id="Rectangle_24" data-name="Rectangle 24" width="9" height="71" rx="4.5"
                  transform="translate(216.92 146.716) rotate(45)" fill="#fff"/>
          </g>
        </g>
      </svg>
    </div>

    <p v-html="correctAnswer"
       class="correct-answer-box">
    </p>

    <p class="why-text">
      Why we make it
    </p>

    <button
        @click="handleSubmit"
        class="result-btn transition"
    >
      <span v-if="id !== 9"> {{ $t('nextQuestion') }}</span>
      <span v-else> {{ $t('finishedQuiz') }}</span>
      <svg id="Group_8" class="responsive-svg" data-name="Group 8" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink" width="10.016" height="17.369" viewBox="0 0 10.016 17.369">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_20" data-name="Rectangle 20" width="10.016" height="17.369" fill="#fff"/>
          </clipPath>
        </defs>
        <g id="Group_7" data-name="Group 7" clip-path="url(#clip-path)">
          <path id="Path_5" data-name="Path 5"
                d="M10.016,8.671,1.615.27l0,0h0A.949.949,0,0,0,.269,1.608h0L7.344,8.683.271,15.757h0A.949.949,0,0,0,1.611,17.1h0l8.4-8.4L10,8.683Z"
                transform="translate(0 0)" fill="#fff"/>
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    isCorrect: Boolean,
    correctAnswer: String,
    id: Number
  },
  methods: {
    handleSubmit() {
      this.$emit("next");
    },
  },
};
</script>


<style scoped>
.result-icon-container {
  display: flex;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 25px;
}

.correct-answer-box {
  height: 266px;
  width: 266px;
  display: grid;
  place-content: center;
  text-align: center;
  background-color: white;
  color: #CD0000;
  padding: 40px 22px;
  font-size: 18px;
}

.why-text {
  font-size: 18px;
  font-style: italic;
  font-weight: 800;
  padding-top: 55px;
  padding-bottom: 30px;
}

.result-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 12px 15px;
  border-radius: 9999px;
  border: 1px solid white;
  font-size: 12px;
  font-weight: 600;
}

.result-btn:hover {
  color: #e18b8b;
}

.resultsIcon {
  width: 116px;
  height: 116px;
}

.responsive-svg {
  width: 10px;
  height: 17px;
}

@media (min-width: 900px) {
  .result-icon-container {
    padding-top: 30px;
    padding-bottom: 60px;
  }

  .correct-answer-box {
    height: 65vw;
    width: 65vw;
    padding: 50px 30px;
    font-size: 48px;
  }

  .why-text {
    font-size: 48px;
    padding-top: 120px;
    padding-bottom: 70px;
  }

  .result-btn {
    gap: 40px;
    padding: 20px 40px;
    font-size: 32px;
  }

  .resultsIcon {
    width: 25vw;
    height: 25vw;
  }

  .responsive-svg {
    width: 18px;
    height: 30px;
  }
}
</style>